import * as signalR from "@microsoft/signalr";

let isConnected = false;

const negotiateUrl = `${process.env.REACT_APP_NOTIFICACAO_URL}/negotiate?negotiateVersion=1`;

const negotiateConnection = async () => {
    try {
        const response = await fetch(negotiateUrl, {
            method: "POST", 
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Erro na negociação SignalR: ${response.status} ${response.statusText}`);
        }

        const negotiateData = await response.json();

        return negotiateData;
    } catch (error) {
        console.error("Erro ao negociar conexão com SignalR:", error);
        throw error;
    }
};

// Configura o SignalR Connection com dados negociados
const configureConnection = async () => {
    const negotiateData = await negotiateConnection();

    return new signalR.HubConnectionBuilder()
        .withUrl(negotiateData.url, {
            accessTokenFactory: () => negotiateData.accessToken,
            withCredentials: true,
        })
        .withAutomaticReconnect([0, 2000, 10000, 30000])
        .configureLogging(signalR.LogLevel.Information)
        .build();
};

let connection;

// Função para iniciar a conexão
export const startConnection = async () => {
    if (connection?.state !== signalR.HubConnectionState.Disconnected || isConnected) {
        console.log("Tentativa de conexão ignorada: já está conectando ou conectado.");
        return;
    }

    try {
        connection = await configureConnection();
        await connection.start();
        isConnected = true;
        console.log("Conectado ao SignalR!");
    } catch (error) {
        console.error("Erro ao conectar com SignalR", error);
        isConnected = false;
        setTimeout(startConnection, 5000); // Tenta conectar novamente após 5 segundos
    }
};

// Lida com o evento de reconexão
connection?.onreconnecting((error) => {
    console.warn("Tentando reconectar ao SignalR devido ao erro:", error);
    isConnected = false;
});

// Lida com reconexão bem-sucedida
connection?.onreconnected((connectionId) => {
    console.log("Reconectado ao SignalR. Novo ConnectionId:", connectionId);
    isConnected = true;
});

// Lida com a perda de conexão e tenta reconectar
connection?.onclose((error) => {
    console.error("Conexão SignalR perdida. Reconexão automática será tentada...", error);
    isConnected = false;
});

// Configura o callback para receber notificações
export const onRecebeNotificacao = (callback) => {
    connection?.on("ConfirmarPresenca", (nomeProfissional, nomePaciente, hora) => {
        console.log("Notificação recebida no cliente:", nomeProfissional, nomePaciente, hora);
        callback(nomeProfissional, nomePaciente, hora);
    });
};

// Função para enviar uma confirmação de presença
export const confirmarPresenca = async (profissionalId, nomeProfissional, nomePaciente, hora) => {
    try {
        if (connection?.state !== signalR.HubConnectionState.Connected) {
            console.warn("Tentando reconectar ao SignalR...");
            await startConnection();
        }
        await connection.invoke("ConfirmarPresenca", profissionalId, nomeProfissional, nomePaciente, hora);
        console.log("Presença confirmada com sucesso!");
    } catch (error) {
        console.error("Erro ao confirmar presença:", error.message || error);
    }
};

// Função para marcar falta
export const marcarFalta = async (profissionalId, nomeProfissional, nomePaciente, hora) => {
    if (!isConnected) {
        console.warn("Não está conectado ao SignalR. Tentando conectar...");
        await startConnection();
    }

    try {
        await connection.invoke("MarcarFalta", profissionalId, nomeProfissional, nomePaciente, hora);
    } catch (error) {
        console.error("Erro ao enviar mensagem", error);
    }
};

// Inicia a conexão inicialmente
startConnection();
